import { render, staticRenderFns } from "./kc_index.vue?vue&type=template&id=32ad2bec"
import script from "./kc_index.vue?vue&type=script&lang=js"
export * from "./kc_index.vue?vue&type=script&lang=js"
import style0 from "./kc_index.vue?vue&type=style&index=0&id=32ad2bec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports